import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import PropTypes from 'prop-types';
//import { renderContentFromMetadata } from '@jutro/uiconfig';
import { MetadataContent } from '@jutro/uiconfig';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';
import { NotificationService } from 'gw-capability-ri-policy-admin';
import { useAuthentication } from 'gw-digital-auth-react';
import { ButtonLink } from '@jutro/router';
// import { EditBCNotification } from '../EditBCNotification/EditBCNotification';
import { ModalNextProvider, useModal} from '@jutro/components';
import metadata from './NotificationList.metadata.json5';
import styles from './NotificationList.module.scss';
import notificationMessages from '../../Notification.messages';

const CANCEL = 'cancel'; const
    CONFIRM = 'confirm';

function NotificationList(props) {
    const { billingId, onAdd, refresh, showAddNotification, isEditing } = props;
    const { authHeader } = useAuthentication();
    const [notificationDataTable, setNotificationDataTable] = useState([]);
    const [isLoading, setLoadingState] = useState(false);

    const [searchFilter, setSearchFilter] = useState(undefined);
    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const {showConfirm,
        showAlert} = useModal();

    useEffect(() => {
        loadNotificationData();
    }, [billingId, refresh]);

    const getNotifications = useCallback(
        () => {
            if (!(billingId === undefined)) {
                const notificationPromise = NotificationService.getSubscriptionsById(billingId, authHeader);
                return notificationPromise
                    .then((responseData) => {
                        const data = processNotificationData(responseData);
                        setNotificationDataTable(data);
                    })
                    .finally(() => {
                        setLoadingState(false);
                    });
            }
            setLoadingState(false);
            return {};
        },
        [authHeader, billingId]
    );

    const processNotificationData = useCallback(
        (notificationData) => {
            if (!_.isEmpty(notificationData)) {
                let claimsArrayResult = notificationData;
                claimsArrayResult = claimsArrayResult.map((info) => {
                    const arr = [info.effectiveDate[0], info.effectiveDate[1] - 1, info.effectiveDate[2], info.effectiveDate[3], info.effectiveDate[4], info.effectiveDate[5]];
                    const date = moment(arr).isValid() ? intl.formatDate(moment(arr), { year: 'numeric', month: 'short', day: 'numeric' }) : '';
                    const notifications = {
                        accountNumbers: getLinkedAccount(info.metadata.accountNumber),
                        modifiedDate: date,
                        channelType: info.channel.channelType,
                        email: (info.channel.channelType === 'EMAIL') ? info.channel.channelValue : '',
                        phone: (info.channel.channelType === 'SMS') ? info.channel.channelValue : '',
                        createdBy: info.metadata.riUser,
                        type: info.metadata.name,
                        ownerSubscriptionId: info.ownerSubscriptionId,
                        ownerId: info.ownerId,
                        subscriptionId: info.subscriptionId,
                        notificationSource: 'billing'
                    };
                    return notifications;
                });
                return claimsArrayResult;
            }
            return [];
        },
        [intl, translator]
    );

    const loadNotificationData = useCallback(
        (filters) => {
            setLoadingState(true);

            let claimStates = '' ? ['open', 'draft', 'closed'] : ['open', 'draft'];
            let queryText = searchFilter;

            if (!_.isUndefined(filters)) {
                if (!_.isUndefined(filters.isClosed)) {
                    claimStates = filters.isClosed
                        ? ['open', 'draft', 'closed']
                        : ['open', 'draft'];
                }
                queryText = !_.isUndefined(filters.queryText) ? filters.queryText : queryText;
            }

            const query = {
                claimStates: claimStates,
                queryText: queryText
            };

            return getNotifications(query);
        },
        [searchFilter, billingId, translator]
    );

    const getLinkedAccount = (valueArray) => {
        if (!_.isUndefined(valueArray)) {
            return valueArray.toString();
        }
        return [];
    };

    const handleFilterChange = useCallback(
        (value, id) => {
            if (id === 'LOBFilter' && value !== 'Filters') {
                loadNotificationData({ policyType: value });
            }
            if (id === 'searchFilter') {
                loadNotificationData({ queryText: value });
            }
        },
        [loadNotificationData]
    );

    const getCell = useCallback(
        (item, index, property) => {
            const toolTipMessage = {
                // product: translator(claimsMessages.line),
                // dateOfLoss: translator(claimsMessages.dateOfLossClaimDetail)
            };
            return <span title={toolTipMessage[property.id]}>{item[property.id]}</span>;
        },
        [translator]
    );

    const updateLink = useCallback((item, index, property) => {
        //        const { authHeader, isLoading, currentView } = this.state;
        // this.setState({ isDocLoading: true, docRetrieveIndicator: true });
        const redirectpath = {
            pathname: '/ri-claims-fnol', /* ${item[property]}*/
            state: {
                fnolid: item[property],
                redirectPath: '/ri-claims/tile',
            }
        };
        return (
            <ButtonLink to={redirectpath} className={styles.ri__ActionColumn__continueButton}>
                Update
            </ButtonLink>
        );
    });

    const deleteSubscription = useCallback((event) => {
        const alertMessage = {
            title: `Delete the Notification for "${event.accountNumbers}"`,
            message: `You are about to delete the notification for the Associated Accounts: "${event.accountNumbers}"!`,
            status: 'warning',
            icon: 'mi-error-outline'
        };

        showConfirm(alertMessage).then((results) => {
            if (results === CONFIRM) {
                doDeleteSubscription(event);
            }
        });
    });

    const doDeleteSubscription = useCallback((event) => {
        // alert(JSON.stringify(event));
        const param = {
            ownerSubscriptionId: event.ownerSubscriptionId,
            ownerId: event.ownerId
        };

        NotificationService.deleteBCSubscription(param, authHeader).then((responseData) => {
            // alert(JSON.stringify(responseData));
            loadNotificationData();
        }).finally(() => {
            setLoadingState(false);
        });
    });

    const overrides = {
        claimListTableLoader: {
            loaded: !isLoading
        },
        claimTable: {
            data: notificationDataTable,
            visible: !isLoading
        },
        noDataMessageContainer: {
            visible: _.isEmpty(notificationDataTable) && !isLoading
        },
        noDataMessage: {
            value: translator(notificationMessages.noNotificationsResult)
        },
        addNewButton: {
            visible: !showAddNotification && !isEditing
        },
        ownerSubscriptionId: {
            visible: !isEditing
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell: getCell,
            handleFilterValue: handleFilterChange,
            handleAdd: onAdd,
            deleteSubscription: deleteSubscription,
            doDeleteSubscription
        },
        resolveComponentMap: {
            // claimloboptionsmenu: ClaimLobOptionsMenu
        }
    };

    //return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
}

NotificationList.propTypes = {
    billingId: PropTypes.string,
    onAdd: PropTypes.func.isRequired,
    refresh: PropTypes.number
};

NotificationList.defaultProps = {
    billingId: undefined
};

export default withRouter(NotificationList);
